import BaseComponent from "../../baseComponent.js";
import AppConfig from "../../../config/config.js";
import styles from "./legends.scss";

export default class Legends extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleClick (index) {
    var _this = this;
    return function (event) {
      $(event.currentTarget).toggleClass("legend-item--deactivated");
      _this.props.onToggleLegend(index);
    }
  }

  handleMouseHover (index) {
    var _this = this;
    return function (event) {
      _this.props.onLegendHover(index);
    }
  }

  render () {
    var legends = [];
    for (var i = 0; i < this.props.datasets.length; i++) {
      legends.push(<div className="legend-item" key={i}
                        onMouseEnter={this.handleMouseHover(i)}
                        onMouseLeave={this.handleMouseHover(-1)}
                        onClick={this.handleClick(i)}>
        <div className="legend-item__color" style={{background: AppConfig.EXTENDED_LEGEND_COLORS[i]}}></div>
        <div className="legend-item__label">{this.props.datasets[i].name}</div>
      </div>)
    }

    return (
      <div className="profile-container">
        <div className="profile-legends">
          {legends}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/analysis/legends.jsx